import script from "./ImageModalComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageModalComponent.vue?vue&type=script&setup=true&lang=js"

import "./ImageModalComponent.vue?vue&type=style&index=0&id=7dea726a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dea726a"]])

export default __exports__